import { ChangeDetectionStrategy, Component } from '@angular/core';
import { cloudTransformUrl } from '@staticassets/stream/cdn/cloud-media';

@Component({
  selector: 'app-video-post',
  templateUrl: './video-post.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VideoPostComponent {
  cloudTransformUrl = cloudTransformUrl;

}
